module.exports = __webpack_public_path__ + "img/add-employee.912dfe6a.gif";